module.exports = __webpack_public_path__ + "static/media/25-nodejs.cc2b3aaf.svg";